import React from "react";

import { motion, useReducedMotion } from "framer-motion";

import LandingMenu from "../../../components/layout/LandingMenu";
import LoginButton from "../../../components/layout/LoginButton";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import LandingFooter from "../../../components/layout/LandingFooter";

import legupLogo from "../../../assets/legup-logo.svg";

import FaqSection from "./FaqSection";

import "./FaqPage.css";

export default function FaqPage() {
  const prefersReducedMotion = useReducedMotion();

  const headerVariants = {
    hidden: {
      opacity: 0,

      y: prefersReducedMotion ? 0 : -16,
    },

    visible: {
      opacity: 1,

      y: 0,

      transition: {
        duration: prefersReducedMotion ? 0.01 : 0.58,

        ease: [0.22, 1, 0.36, 1],

        staggerChildren: prefersReducedMotion ? 0 : 0.07,
      },
    },
  };

  const headerItemVariants = {
    hidden: {
      opacity: 0,

      y: prefersReducedMotion ? 0 : -10,
    },

    visible: {
      opacity: 1,

      y: 0,

      transition: {
        duration: prefersReducedMotion ? 0.01 : 0.48,

        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <div className="faq-page">
      {/* =====================================================
          HEADER
          ===================================================== */}

      <motion.header
        className="faq-page__header"
        initial="hidden"
        animate="visible"
        variants={headerVariants}
      >
        {/* ---------------- LEFT ---------------- */}

        <motion.div
          className="faq-page__header-left"
          variants={headerItemVariants}
        >
          <LandingMenu />
        </motion.div>

        {/* ---------------- LOGO ---------------- */}

        <motion.a
          className="faq-page__brand"
          href="/"
          aria-label="LEG-UP"
          variants={headerItemVariants}
        >
          <img src={legupLogo} alt="LEG-UP" />
        </motion.a>

        {/* ---------------- RIGHT ---------------- */}

        <motion.div
          className="faq-page__header-right"
          variants={headerItemVariants}
        >
          <LanguageSwitcher />

          <LoginButton />
        </motion.div>
      </motion.header>

      <main className="faq-page__main">
        <FaqSection />
      </main>

      <LandingFooter />
    </div>
  );
}
